import miscServices from '@/services/misc';
import _ from 'lodash';

function initialState () {
  return {
    divisions: [],
    globalOptions: [],
    accounting_settings: {},
    settings: {},
    woTypes: [],
    refreshRequired: false
  }
}

const state = initialState()

const actions = {
  loadDivisions (context, divs) {
    context.commit('loadDivisions', divs)
  },
  loadGlobalOptions (context, opts) {
    context.commit('loadGlobalOptions', opts)
  },
  loadSettings (context, opts) {
    context.commit('loadSettings', opts)
  },
  loadAccountingSettings(context, opts){
    context.commit('loadAccountingSettings', opts);
  },
  loadWOTypes (context, payload) {
    context.commit('loadWOTypes', payload)
  },
  resetMisc ({ commit }) {
    commit('resetMisc')
  },
  replaceDivision (context, obj) {
    context.commit('replaceDivision', obj)
  },
  setRefreshRequired (context, val) {
    context.commit('setRefreshRequired', val)
  }
}

const mutations = {
  resetMisc (state) {
    // acquire initial state
    const s = initialState()
    Object.keys(s).forEach(key => {
      state[key] = s[key]
    })
  },
  loadDivisions (state, divs) {
    state.divisions = divs
  },
  loadGlobalOptions (state, opts) {
    state.globalOptions = opts
  },
  loadSettings (state, opts) {
    state.settings = opts
  },
  loadAccountingSettings(state, opts){
    state.accounting_settings = opts;
  },
  loadWOTypes (state, payload) {
    state.woTypes = _.orderBy(payload, "name")
  },
  replaceDivision (state, obj) {
    state.divisions = miscServices.replaceObject(state.divisions, obj)
  },
  setRefreshRequired (state, val) {
    state.refreshRequired = val
  }
}

export default {
  state,
  actions,
  mutations
}
